import { d as _objectSpread2, e as _toConsumableArray, _ as _objectWithoutProperties, a as _extends, b as _slicedToArray } from '../_rollupPluginBabelHelpers-b0164b33.js';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Bem from '../packages/honey-bem.js';
import { Injecss } from '../packages/injecss.js';
import { a as IconArrowLeft, b as IconArrowRight } from '../index-1707f584.js';
import { Icon } from '../components/icon.js';
import '../index-c4501d32.js';
import { Button } from '../components/button.js';
import { Heading } from '../components/heading.js';
import { Select } from '../components/select.js';

var styles = {
raw: ".hcr-clndr-1-6-0{border-radius:5px;background-color:#fff;-webkit-box-shadow:0 0 12px rgba(0,0,0,.12);box-shadow:0 0 12px rgba(0,0,0,.12);z-index:10}.hcr-clndr--flat-1-6-0{border-radius:0;-webkit-box-shadow:none;box-shadow:none}.hcr-clndr__month-1-6-0{padding:12px}.hcr-clndr__caption-1-6-0,.hcr-clndr__table-1-6-0{width:100%}.hcr-clndr__title-1-6-0{text-align:center}.hcr-clndr__btn-1-6-0,.hcr-clndr__cell-1-6-0{position:relative;font-family:Roboto Condensed,Arial,sans-serif;line-height:36px;text-align:center}.hcr-clndr__btn-1-6-0{background:transparent;font-size:16px;cursor:pointer;-webkit-appearance:none;-moz-appearance:none;appearance:none;display:block;width:36px;height:36px;margin:0 auto;-webkit-transition:border-color .2s;transition:border-color .2s;border:1px solid transparent;border-radius:5px}.hcr-clndr__btn--end-1-6-0,.hcr-clndr__btn--selected-1-6-0,.hcr-clndr__btn--start-1-6-0{background-color:#73d700;color:#fff}.hcr-clndr__btn--start-1-6-0{background-color:#a6ec55;color:#444}.hcr-clndr__btn--end-1-6-0 span:before,.hcr-clndr__btn--start-1-6-0 span:before{position:absolute;top:50%;width:0;height:0;margin-top:-6px;border:6px solid transparent;content:\" \";pointer-events:none}.hcr-clndr__btn--start-1-6-0 span:before{left:100%;border-left-color:#a6ec55}.hcr-clndr__btn--end-1-6-0 span:before{right:100%;border-right-color:#73d700}.hcr-clndr__btn-1-6-0:hover{border-color:#73d700}.hcr-clndr__btn--disabled-1-6-0{cursor:not-allowed;opacity:.5}.hcr-clndr__btn--disabled-1-6-0:hover{border-color:transparent}.hcr-clndr-header-1-6-0{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-justify-content:space-around;-ms-flex-pack:distribute;justify-content:space-around;margin-bottom:12px}.hcr-clndr-header--compact-1-6-0 button:first-child{margin-right:12px}.hcr-clndr-header--compact-1-6-0 button:last-child{margin-left:12px}.hcr-clndr-header--birthday-1-6-0{-webkit-box-pack:start;-webkit-justify-content:flex-start;-ms-flex-pack:start;justify-content:flex-start}.hcr-clndr-1-6-0 .hcr-clndr-header__select-1-6-0{-webkit-box-flex:1;-webkit-flex-grow:1;-ms-flex-positive:1;flex-grow:1}.hcr-clndr-1-6-0 .hcr-clndr-header__select-1-6-0:first-child{margin-right:6px}.hcr-clndr-1-6-0 .hcr-clndr-header__select-1-6-0:last-child{margin-left:6px}@media (min-width:1200px){.hcr-clndr-1-6-0 .hcr-clndr-header__select-1-6-0:after{top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}}",
map:{"hcr-clndr":"hcr-clndr-1-6-0","hcr-clndr--flat":"hcr-clndr--flat-1-6-0","hcr-clndr__month":"hcr-clndr__month-1-6-0","hcr-clndr__table":"hcr-clndr__table-1-6-0","hcr-clndr__caption":"hcr-clndr__caption-1-6-0","hcr-clndr__title":"hcr-clndr__title-1-6-0","hcr-clndr__btn":"hcr-clndr__btn-1-6-0","hcr-clndr__cell":"hcr-clndr__cell-1-6-0","hcr-clndr__btn--start":"hcr-clndr__btn--start-1-6-0","hcr-clndr__btn--end":"hcr-clndr__btn--end-1-6-0","hcr-clndr__btn--selected":"hcr-clndr__btn--selected-1-6-0","hcr-clndr__btn--disabled":"hcr-clndr__btn--disabled-1-6-0","hcr-clndr-header":"hcr-clndr-header-1-6-0","hcr-clndr-header--compact":"hcr-clndr-header--compact-1-6-0","hcr-clndr-header--birthday":"hcr-clndr-header--birthday-1-6-0","hcr-clndr-header__select":"hcr-clndr-header__select-1-6-0"}};

var isSameMonth = function isSameMonth(a, b) {
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth();
};
var isSameDate = function isSameDate(a, b) {
  return isSameMonth(a, b) && a.getDate() === b.getDate();
};
/** Normalizes time for date given to be a default 00:00:00
 * @param date - Date object
 * @returns DateConstructor
 */

var trimTimeFromDate = function trimTimeFromDate(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};

var dayFactory = function dayFactory(_ref) {
  var date = _ref.date,
      rest = _objectWithoutProperties(_ref, ["date"]);

  return _objectSpread2({
    weekday: date.getDay(),
    number: date.getDate(),
    month: date.getMonth(),
    year: date.getFullYear(),
    date: date
  }, rest);
}; // creates an array of arrays of length 7
// representing the smallest required amount of full weeks to display a month


var monthFactory = function monthFactory(year, month) {
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var startDateRaw = arguments.length > 3 ? arguments[3] : undefined;
  var endDateRaw = arguments.length > 4 ? arguments[4] : undefined;
  // passing `new Date()` as prop value in here adds current time that breaks date comparisons,
  // making sure all the received dates from props have default time 00:00:00
  var startDate = trimTimeFromDate(startDateRaw);
  var endDate = trimTimeFromDate(endDateRaw); // first day of week of this month

  var startWeekDay = new Date(year, month, 1).getDay(); // calculate how many days of the previous month are required to match layout

  var padStartLength = 0;
  if (offset > startWeekDay) padStartLength = 7 - startWeekDay - offset;
  if (startWeekDay > offset) padStartLength = startWeekDay - offset; // if days from previous month are needed

  var startPad = padStartLength && new Array(padStartLength).fill(null).map(function (_, i) {
    // time travel in JS (negative days simply go back in time)
    var date = new Date(year, month, 0 - i);
    return dayFactory({
      date: date,
      disabled: date < startDate || date > endDate,
      prev: true
    });
  }).reverse() || []; // add all days in this current month, no check required

  var days = new Array(new Date(year, month + 1, 0).getDate()).fill(null).map(function (_, i) {
    var date = new Date(year, month, i + 1);
    return dayFactory({
      date: date,
      disabled: date < startDate || date > endDate
    });
  }); // calculate how many days at end of the month are required to reach a week of length 7

  var right = (startPad.length + days.length) % 7;
  var padEndLength = right === 0 || right === 7 ? 0 : 7 - right; // if days are required

  var endPad = padEndLength && new Array(Math.abs(padEndLength)).fill(null).map(function (_, i) {
    // ensure correct next month/year depending on current month
    var nextOrCurrentMonth = month <= 10 ? month + 1 : 0;
    var nextOrCurrentYear = month <= 10 ? year : year + 1;
    var date = new Date(nextOrCurrentYear, nextOrCurrentMonth, 1 + i);
    return dayFactory({
      date: date,
      disabled: date < startDate || date > endDate,
      next: true
    });
  }) || []; // concat all days (previous, current and next month)

  var merge = [].concat(_toConsumableArray(startPad), _toConsumableArray(days), _toConsumableArray(endPad)); // split in weeks

  var weeks = [];

  for (var i = 0; i < merge.length; i += 7) {
    weeks.push(merge.slice(i, i + 7));
  }

  return weeks;
}; // generates an object which key 'months'
// contains all month required by the calendar

var calendarFactory = function calendarFactory(start, end) {
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var months = [];
  var years = []; // maximum amount of required months by provided years

  var n = (end.getFullYear() - start.getFullYear() + 1) * 12; // for each month

  var _loop = function _loop(i) {
    // check if month is actually needed, if not, skip
    if (i % 12 < start.getMonth() && i < 11 || i % 12 > end.getMonth() && i > n - 11) {
      return "continue"; // eslint-disable-line no-continue
    } // current year


    var year = start.getFullYear() + Math.floor(i / 12); // if year is in index, add it

    if (years.findIndex(function (y) {
      return y === year;
    }) === -1) years.push(year); // for each month add an entry

    months.push({
      year: year,
      month: i % 12,
      // weeks are generated by month factory
      weeks: monthFactory(year, i % 12, offset, start, end)
    });
  };

  for (var i = 0; i < n; i += 1) {
    var _ret = _loop(i);

    if (_ret === "continue") continue;
  }

  return {
    months: months,
    years: years
  };
};

var bem = Bem('clndr-header', styles);
var HeaderBirthday = function HeaderBirthday(_ref) {
  var calendar = _ref.calendar,
      months = _ref.months,
      selected = _ref.selected,
      onChangeDate = _ref.onChangeDate,
      birthdaySelectMonth = _ref.birthdaySelectMonth,
      birthdaySelectYear = _ref.birthdaySelectYear,
      id = _ref.id;

  var onMonthChange = function onMonthChange(e) {
    onChangeDate(new Date(selected.getFullYear(), months.findIndex(function (month) {
      return month === e.target.value;
    }), 1));
  };

  var onYearChange = function onYearChange(e) {
    onChangeDate(new Date(parseInt(e.target.value, 10), selected.getMonth(), 1));
  };

  return React.createElement("div", {
    className: bem.b('birthday')
  }, React.createElement(Select, _extends({
    extraClasses: bem.e('select'),
    id: "".concat(id, "-month-select"),
    options: months.map(function (month) {
      return {
        value: month
      };
    }),
    onChange: onMonthChange,
    value: months[selected.getMonth()]
  }, birthdaySelectMonth)), React.createElement(Select, _extends({
    extraClasses: bem.e('select'),
    id: "".concat(id, "-year-select"),
    options: calendar.years.map(function (year) {
      return {
        value: year
      };
    }),
    onChange: onYearChange,
    value: selected.getFullYear()
  }, birthdaySelectYear)));
};
HeaderBirthday.propTypes = {
  id: PropTypes.string.isRequired,
  calendar: PropTypes.object.isRequired,
  months: PropTypes.arrayOf(PropTypes.string).isRequired,
  selected: PropTypes.instanceOf(Date).isRequired,
  onChangeDate: PropTypes.func.isRequired,
  birthdaySelectMonth: PropTypes.object.isRequired,
  birthdaySelectYear: PropTypes.object.isRequired
};

var bem$1 = Bem('clndr-header', styles);
var HeaderCompact = function HeaderCompact(_ref) {
  var calendar = _ref.calendar,
      months = _ref.months,
      onPrev = _ref.onPrev,
      hasPrev = _ref.hasPrev,
      selected = _ref.selected,
      onNext = _ref.onNext,
      onChangeDate = _ref.onChangeDate,
      hasNext = _ref.hasNext,
      compactPrevButton = _ref.compactPrevButton,
      compactNextButton = _ref.compactNextButton,
      compactSelect = _ref.compactSelect,
      id = _ref.id;
  return React.createElement("div", {
    className: bem$1.b('compact')
  }, React.createElement(Button, _extends({
    appearance: "tertiary",
    display: "square",
    id: "".concat(id, "-calendar-prev-button"),
    onClick: onPrev,
    disabled: hasPrev
  }, compactPrevButton), React.createElement(Icon, {
    InlineIcon: IconArrowLeft
  })), React.createElement(Select, _extends({
    extraClasses: bem$1.e('select'),
    id: "".concat(id, "-month-year-select"),
    options: calendar.months.map(function (_ref2) {
      var month = _ref2.month,
          year = _ref2.year;
      return {
        value: "".concat(new Date(year, month, 1).toDateString()),
        displayValue: "".concat(months[month], " ").concat(year)
      };
    }),
    value: new Date(selected.getFullYear(), selected.getMonth(), 1).toDateString(),
    onChange: function onChange(e) {
      return onChangeDate(new Date(e.target.value));
    }
  }, compactSelect)), React.createElement(Button, _extends({
    appearance: "tertiary",
    display: "square",
    id: "".concat(id, "-calendar-prev-button"),
    onClick: onNext,
    disabled: hasNext
  }, compactNextButton), React.createElement(Icon, {
    InlineIcon: IconArrowRight
  })));
};
HeaderCompact.defaultProps = {
  hasPrev: true,
  hasNext: true
};
HeaderCompact.propTypes = {
  calendar: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  selected: PropTypes.instanceOf(Date).isRequired,
  months: PropTypes.arrayOf(PropTypes.string).isRequired,
  onPrev: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  onChangeDate: PropTypes.func.isRequired,
  hasPrev: PropTypes.bool,
  hasNext: PropTypes.bool,
  compactPrevButton: PropTypes.object.isRequired,
  compactNextButton: PropTypes.object.isRequired,
  compactSelect: PropTypes.object.isRequired
};

var bem$2 = Bem('clndr', styles);
var Calendar = function Calendar(_ref) {
  var months = _ref.months,
      daysShort = _ref.daysShort,
      firstDayOfWeek = _ref.firstDayOfWeek,
      selected = _ref.selected,
      startSelected = _ref.startSelected,
      defaultMonth = _ref.defaultMonth,
      endSelected = _ref.endSelected,
      startDate = _ref.startDate,
      endDate = _ref.endDate,
      handleSelect = _ref.handleSelect,
      flat = _ref.flat,
      appearance = _ref.appearance,
      hidden = _ref.hidden,
      compactPrevButton = _ref.compactPrevButton,
      compactNextButton = _ref.compactNextButton,
      compactSelect = _ref.compactSelect,
      birthdaySelectMonth = _ref.birthdaySelectMonth,
      birthdaySelectYear = _ref.birthdaySelectYear,
      dayLabel = _ref.dayLabel,
      testCalendar = _ref.testCalendar,
      id = _ref.id,
      extraClasses = _ref.extraClasses;

  // all required states
  var _useState = useState(testCalendar),
      _useState2 = _slicedToArray(_useState, 2),
      calendar = _useState2[0],
      setCalendar = _useState2[1];

  var _useState3 = useState(defaultMonth),
      _useState4 = _slicedToArray(_useState3, 2),
      displayedMonth = _useState4[0],
      setDisplayedMonth = _useState4[1];

  var _useState5 = useState(testCalendar),
      _useState6 = _slicedToArray(_useState5, 2),
      displayedCalendar = _useState6[0],
      setDisplayedCalendar = _useState6[1]; // if calendar changes recompute displayedCalendar


  useEffect(function () {
    setDisplayedCalendar(calendar !== null && appearance !== 'list' && displayedMonth ? _objectSpread2({}, calendar, {
      months: [calendar.months.find(function (_ref2) {
        var year = _ref2.year,
            month = _ref2.month;
        return isSameMonth(displayedMonth, new Date(year, month, 1));
      }) || calendar.months[0]]
    }) : calendar);
  }, [calendar, displayedMonth]); // updating the calendar when changing the defaultMonth

  useEffect(function () {
    // we won't set month if the value provided is outside of start/end date range
    if (defaultMonth > startDate && defaultMonth < endDate) {
      setDisplayedMonth(defaultMonth);
    }
  }, [defaultMonth.getTime(), startDate.getTime(), endDate.getTime()]); // is start/end/weekStart change, recalculate calendar

  useEffect(function () {
    setCalendar(calendarFactory(startDate, endDate, firstDayOfWeek));
  }, [startDate.getTime(), endDate.getTime(), firstDayOfWeek]); // Prev month handler

  var onPrev = function onPrev() {
    setDisplayedMonth(new Date(displayedMonth.getFullYear(), displayedMonth.getMonth() - 1, 1));
  }; // Next month handler


  var onNext = function onNext() {
    setDisplayedMonth(new Date(displayedMonth.getFullYear(), displayedMonth.getMonth() + 1, 1));
  }; // Change date handler


  var onChangeDate = function onChangeDate(date) {
    return setDisplayedMonth(date);
  }; // hide


  if (hidden) return null;
  return React.createElement("div", {
    className: bem$2.b({
      flat: flat
    }, extraClasses)
  }, displayedCalendar !== null && displayedCalendar.months.map(function (_ref3) {
    var weeks = _ref3.weeks,
        month = _ref3.month,
        year = _ref3.year;
    return React.createElement("div", {
      className: bem$2.e('month'),
      key: "".concat(year, "-").concat(month)
    }, appearance === 'compact' && React.createElement(HeaderCompact, {
      hasPrev: isSameMonth(displayedMonth, startDate),
      onPrev: onPrev,
      hasNext: isSameMonth(displayedMonth, endDate),
      onNext: onNext,
      onChangeDate: onChangeDate,
      selected: displayedMonth,
      calendar: calendar,
      months: months,
      compactPrevButton: compactPrevButton,
      compactNextButton: compactNextButton,
      compactSelect: compactSelect,
      id: id
    }), appearance === 'birthday' && React.createElement(HeaderBirthday, {
      selected: displayedMonth,
      calendar: calendar,
      onChangeDate: onChangeDate,
      months: months,
      birthdaySelectMonth: birthdaySelectMonth,
      birthdaySelectYear: birthdaySelectYear,
      id: id
    }), React.createElement("table", {
      className: bem$2.e('table')
    }, React.createElement("caption", {
      className: bem$2.e('caption')
    }, appearance === 'list' && React.createElement(Heading, {
      extraClasses: bem$2.e('title'),
      size: 3,
      sectionHeader: true
    }, "".concat(months[month], " ").concat(year))), React.createElement("tbody", null, React.createElement("tr", null, new Array(7).fill(null).map(function (_, day) {
      return React.createElement("th", {
        key: daysShort[day],
        className: bem$2.e('cell')
      }, React.createElement("span", null, daysShort[day]));
    })), weeks.map(function (days) {
      return React.createElement("tr", {
        key: "w-".concat(days[0].date.getFullYear(), "-").concat(days[0].date.getMonth(), "-").concat(days[0].number)
      }, days.map(function (_ref4) {
        var number = _ref4.number,
            date = _ref4.date,
            disabled = _ref4.disabled,
            prev = _ref4.prev,
            next = _ref4.next;
        return React.createElement("td", {
          key: "".concat(date.getFullYear(), "-").concat(date.getMonth(), "-").concat(date.getDate()),
          className: bem$2.e('cell')
        }, !prev && !next && disabled && React.createElement("span", {
          className: bem$2.e('btn', 'disabled')
        }, React.createElement("span", null, number)), !prev && !next && !disabled && React.createElement("button", {
          className: bem$2.e('btn', {
            selected: selected !== null && isSameDate(date, selected),
            start: startSelected !== null && isSameDate(date, startSelected),
            end: endSelected !== null && isSameDate(date, endSelected)
          }),
          onClick: function onClick() {
            setDisplayedMonth(date);
            handleSelect(date);
          },
          type: "button",
          disabled: disabled,
          "aria-label": dayLabel(number, month, year)
        }, React.createElement("span", null, number)));
      }));
    }))));
  }));
};
Calendar.displayName = 'Calendar';
Calendar.defaultProps = {
  months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  daysShort: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
  firstDayOfWeek: 1,
  selected: null,
  startSelected: null,
  endSelected: null,
  startDate: new Date(),
  endDate: new Date(2019, 10, 0),
  flat: false,
  handleSelect: function handleSelect() {},
  defaultMonth: new Date(),
  appearance: 'list',
  hidden: false,
  compactPrevButton: {
    'aria-label': 'Previous month'
  },
  compactNextButton: {
    'aria-label': 'Next month'
  },
  compactSelect: {
    'aria-label': 'Select month and year'
  },
  birthdaySelectMonth: {
    'aria-label': 'Select month'
  },
  birthdaySelectYear: {
    'aria-label': 'Select year'
  },
  testCalendar: null,
  dayLabel: function dayLabel(day, month, year) {
    return "Select: ".concat(new Date(year, month, day).toLocaleDateString());
  },
  extraClasses: ''
};
Calendar.propTypes = {
  /** Localized month names starting with January  */
  months: PropTypes.arrayOf(PropTypes.string),

  /** Localized days short names, this will all start at index 0
   * so you will need to adapt this array according to your value of firstDayOfWeek
   */
  daysShort: PropTypes.arrayOf(PropTypes.string),

  /** Javascript index of first day of week (0 === Sunday),
   * note that you will need to  adapt the prop daysShort accordingly */
  firstDayOfWeek: PropTypes.number,

  /** First available day in this calendar  */
  startDate: PropTypes.instanceOf(Date),

  /** Last available day in this calendar  */
  endDate: PropTypes.instanceOf(Date),

  /** Displays a given date as selected */
  selected: PropTypes.instanceOf(Date),

  /** Displays a given date as first/start date */
  startSelected: PropTypes.instanceOf(Date),

  /** Displays a given date as last/end date */
  endSelected: PropTypes.instanceOf(Date),

  /** Callback after an available day is selected */
  handleSelect: PropTypes.func,

  /** Displays calendar as flat (no box-shadow) */
  flat: PropTypes.bool,

  /** When an available day is selected */
  appearance: PropTypes.oneOf(['list', 'compact', 'birthday']),

  /** Preselected month when appearance is compact or birthday */
  defaultMonth: PropTypes.instanceOf(Date),

  /** Hide the calendar but keeps it in memory */
  hidden: PropTypes.bool,

  /** Rest props passed to prev button in compact appearance */
  compactPrevButton: PropTypes.object,

  /** Rest props passed to next button in compact appearance */
  compactNextButton: PropTypes.object,

  /** Rest props passed to select (month + year) in compact appearance */
  compactSelect: PropTypes.object,

  /** Rest props passed to select (month) in birthday appearance */
  birthdaySelectMonth: PropTypes.object,

  /** Rest props passed to select (year) in birthday appearance */
  birthdaySelectYear: PropTypes.object,

  /** Function to return the aria-label value for individual days,
  it takes three arguments: day (number) month (number) year (number) */
  dayLabel: PropTypes.func,

  /** Custom classes name for root element element */
  extraClasses: PropTypes.string,

  /** Overrides auto generated calendar, for testing purposes */
  testCalendar: PropTypes.object,

  /** Id to interpolate with all select fields */
  id: PropTypes.string.isRequired
};
var calendar = Injecss(Calendar, styles);

export { calendar as Calendar };
